module.exports = __webpack_public_path__ + "img/funny_girl.39d4da41.jpg";